'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.for-each");

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var onSubmit = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, dispatch, ownProps) {
    var input, id, _processFields, keyValueFields, stripFields, variables, refetchQueries, _refetchQueries;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            input = _extends({}, removeFileValues(ownProps.fields, values));
            id = input.id || ownProps.id;
            delete input.id;
            console.log('before changes', JSON.stringify(input), JSON.stringify(ownProps.initialValues));
            _processFields = (0, _utils.processFields)(ownProps.fields), keyValueFields = _processFields.keyValueFields, stripFields = _processFields.stripFields; // console.log(keyValueFields)

            (0, _utils.keyValueObjectToArray)(input, keyValueFields); // console.log('to array=', input)

            input = (0, _utils.cleanInput)(input, ownProps.mode === "add" || ownProps.keepInitialValues ? {} : ownProps.initialValues);
            console.log('input=', input); // TODO: Rather use ignore in cleanInput (requires cleanInput to understand arrays)

            console.log('Stripping...', stripFields);
            stripFields && stripFields.forEach(function (field) {
              if (field.indexOf('.*.') > -1) {
                // console.log('This is in an array ...')
                var temp = field.split('.*.'); // console.log('Split it is', temp[0], temp[1])

                var objs = (0, _utils.getField)(input, temp[0]);
                objs && objs.forEach(function (obj) {
                  delete obj[temp[1]];
                });
              }
            });
            variables = {
              input: input
            };

            if (!ownProps.mapInputVariables) {
              _context.next = 16;
              break;
            }

            _context.next = 15;
            return ownProps.mapInputVariables(input);

          case 15:
            variables = _context.sent;

          case 16:
            if (!(ownProps.mode === 'add')) {
              _context.next = 21;
              break;
            } // console.log('in add mode - running mutation')


            refetchQueries = ownProps.refetchQueries || [];
            return _context.abrupt('return', ownProps.mutate({
              variables: variables,
              refetchQueries: refetchQueries
            }).then(function (data) {
              // console.log(data, 'returned')
              if (!ownProps.addOnly) {
                if (ownProps.displayOnSave) {
                  var mutationName = Object.keys(data.data)[0]; // console.log('setting', mutationName, 'id=', data.data[mutationName].id)

                  ownProps.setId(data.data[mutationName].id);
                  ownProps.setMode('display');
                }
              }

              if (ownProps.afterSubmit) {
                ownProps.afterSubmit(data);
              } // ownProps.destroy();

            })["catch"](function (e) {
              console.log(e);
            }));

          case 21:
            console.log('Updating id', variables.id);
            variables = _extends({}, variables, {
              id: id
            });
            _refetchQueries = void 0;

            if (ownProps.refetchQueries) {
              _refetchQueries = [].concat(_toConsumableArray(ownProps.refetchQueries));
            } else {
              _refetchQueries = [{
                query: ownProps.query,
                variables: {
                  id: id
                }
              }];
            }

            return _context.abrupt('return', ownProps.mutate({
              variables: variables,
              refetchQueries: _refetchQueries
            }).then(function (data) {
              if (ownProps.displayOnSave) {
                ownProps.setMode('display');
              }

              if (ownProps.afterSubmit) {
                ownProps.afterSubmit(data);
              } // ownProps.destroy();

            })["catch"](function (e) {
              console.log(e);
            }));

          case 26:
            _context.next = 31;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context['catch'](0);
            console.log(_context.t0);

          case 31:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 28]]);
  }));

  return function onSubmit(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _FormProvider = require('./FormProvider');

var _FormProvider2 = _interopRequireDefault(_FormProvider);

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

var propTypes = {
  id: _propTypes2["default"].string,
  name: _propTypes2["default"].string.isRequired,
  fields: _propTypes2["default"].object.isRequired,
  mode: _propTypes2["default"].string
};
var defaultProps = {
  id: "",
  mode: 'edit'
  /*const cleanInput = (obj, initialValues) => {
    // console.log('intitial is:', initialValues)
    if (obj instanceof Array) { 
      return obj.map(o => cleanInput(o))
    }
    if (obj instanceof Object) {
      const result = {}
      Object.keys(obj).forEach(k => {
        if (k !== '__typename') {
          result[k] = cleanInput(obj[k])
        }
      })  
      return result
    }
    return obj
  }*/

};

var removeField = function removeField(data, name) {
  if (!data) {
    return null;
  }

  var tree = name.replace(/\]/g, '').split(/[\.\[]/);

  if (tree.length == 1) {
    delete data[tree[0]];
  } else {
    if (data[name]) {
      delete data[name];
    } else {
      return removeField(data[tree[0]], tree.slice(1).join('.'));
    }
  }
};

var removeFileValues = function removeFileValues(fields, data) {
  if (data) {
    var values = _extends({}, data);

    Object.keys(fields).forEach(function (fieldPathName) {
      if (fields[fieldPathName].isFile) {
        removeField(values, fieldPathName);
      }
    });
    return values;
  }

  return data;
};

var GraphQLFormProvider = function (_Component) {
  _inherits(GraphQLFormProvider, _Component);

  function GraphQLFormProvider(props) {
    _classCallCheck(this, GraphQLFormProvider); //// console.log('GQLFP Constructor called')


    var _this = _possibleConstructorReturn(this, (GraphQLFormProvider.__proto__ || Object.getPrototypeOf(GraphQLFormProvider)).call(this, props));

    _this.setMode = function (mode) {
      _this.setState({
        mode: mode
      });
    };

    _this.setId = function (id) {
      _this.setState({
        id: id
      });
    };

    _this.state = {
      mode: props.mode,
      id: props.id
    };
    return _this;
  }

  _createClass(GraphQLFormProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {//// console.log('GQLFP CDM')
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      //// console.log(nextProps)
      //// console.log('GQLFP CWRP')
      //objDiff(this.props, nextProps)
      if (nextProps.id !== this.props.id) {
        this.setState({
          id: nextProps.id
        });
      }

      if (nextProps.mode !== this.props.mode) {
        this.setState({
          mode: nextProps.mode
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {} //// console.log('GQLFP CDU Props')
    //objDiff(prevProps, this.props)
    //// console.log('GQLFP CDU State')
    //objDiff(prevState, this.state)
    // TODO: This needs to be refined and checked

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var scu = this.state.mode !== nextState.mode || this.state.id !== nextState.id || this.props.children && this.props.children !== nextProps.children || false; // console.log(this.state.mode, nextState.mode, this.state.id, nextState.id, scu)

      return scu;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          updateMutation = _props.updateMutation,
          _props$updateMutation = _props.updateMutationOptions,
          updateMutationOptions = _props$updateMutation === undefined ? {} : _props$updateMutation,
          addMutation = _props.addMutation,
          _props$addMutationOpt = _props.addMutationOptions,
          addMutationOptions = _props$addMutationOpt === undefined ? {} : _props$addMutationOpt,
          query = _props.query,
          InputFormLayout = _props.InputFormLayout,
          DisplayFormLayout = _props.DisplayFormLayout,
          props = _objectWithoutProperties(_props, ['updateMutation', 'updateMutationOptions', 'addMutation', 'addMutationOptions', 'query', 'InputFormLayout', 'DisplayFormLayout']);

      var _state = this.state,
          mode = _state.mode,
          id = _state.id; // console.log('GraphQLFormProvider is rendering :O', id)

      var MyForm = void 0;

      if (mode == 'add') {
        if (addMutation) {
          MyForm = (0, _reactApollo.graphql)(addMutation, addMutationOptions)(_FormProvider2["default"]);
        } else {
          MyForm = _FormProvider2["default"];
        }
      } else if (mode == 'displayOnly' || !updateMutation) {
        MyForm = (0, _reactApollo.graphql)(query, {
          options: {
            variables: {
              id: id
            }
          }
        })(_FormProvider2["default"]);
      } else {
        MyForm = (0, _reactApollo.graphql)(updateMutation, updateMutationOptions)((0, _reactApollo.graphql)(query, {
          options: {
            variables: {
              id: id
            }
          }
        })(_FormProvider2["default"]));
      }

      return _react2["default"].createElement(MyForm, _extends({}, props, {
        query: query,
        id: id,
        mode: mode,
        onSubmit: onSubmit,
        InputFormLayout: InputFormLayout,
        DisplayFormLayout: DisplayFormLayout,
        initialValuesFromData: this.props.initialValuesFromData || function (data) {
          if (data) {
            return data[props.name] || {};
          }

          return {};
        },
        setId: this.setId,
        setMode: this.setMode
      }));
    }
  }]);

  return GraphQLFormProvider;
}(_react.Component);

GraphQLFormProvider.propTypes = propTypes;
GraphQLFormProvider.defaultProps = defaultProps;
exports["default"] = (0, _reactApollo.withApollo)(GraphQLFormProvider);